// utils/compareNames.js
export const normalizeName = (name) => {
  return name
    .toLowerCase()
    .replace(/[^\w\s]/g, "") // remove punctuation
    .split(" ")
    .filter(Boolean)
    .sort(); // sort words
};

export const compareNames = (name1, name2) => {
  const norm1 = normalizeName(name1);
  const norm2 = normalizeName(name2);
  return JSON.stringify(norm1) === JSON.stringify(norm2);
};
